<script>
import { BModal } from 'bootstrap-vue-next';
import axios from 'axios';
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

export default {
  name: "EditCallHistoryModal",
  components: {
    BModal,
    VueDatePicker
  },
  props: {
    historyEvent: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['history-updated'],
  data() {
    return {
      formData: {
        id: null,
        message: '',
        created_at: null
      },
      isLoading: false,
      error: null
    }
  },
  watch: {
    historyEvent: {
      handler() {
        this.initializeForm();
      },
      deep: true
    }
  },
  methods: {
    initializeForm() {
      if (this.historyEvent && this.historyEvent.id) {
        this.formData = {
          id: this.historyEvent.id,
          message: this.historyEvent.message || '',
          created_at: this.historyEvent.created_at
        };
      }
      this.error = null;
    },
    async saveHistory() {
      this.isLoading = true;
      this.error = null;

      try {
        await axios.post('/call/history/update', this.formData);

        this.$emit('history-updated');
        this.$refs.modal.hide();

      } catch (error) {
        console.error('Error updating call history:', error);
        this.error = error.response?.data?.message || 'Failed to update call history';
      } finally {
        this.isLoading = false;
      }
    },
    show() {
      this.initializeForm();
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    onModalHidden() {
      this.initializeForm();
    }
  },
  computed: {
    modalTitle() {
      return 'Edit Timeline Event';
    }
  }
}
</script>

<template>
  <BModal
    ref="modal"
    :title="modalTitle"
    size="lg"
    @hidden="onModalHidden"
  >
    <!-- Error Alert -->
    <div class="alert alert-danger" v-if="error">
      <i class="bi bi-exclamation-triangle-fill me-2"></i>
      {{ error }}
    </div>

    <!-- Edit Call History Form -->
    <form @submit.prevent="saveHistory" id="editHistoryForm">
      <!-- Date/Time -->
      <div class="row mb-3">
        <label class="col-sm-3 col-form-label">
          <i class="bi bi-calendar-fill me-2"></i>Date:
        </label>
        <div class="col-sm-9">
          <VueDatePicker
            v-model="formData.created_at"
            :enable-time-picker="true"
            :is24="true"
            format="yyyy-MM-dd HH:mm"
            :clearable="false"
          />
        </div>
      </div>

      <!-- Message -->
      <div class="row mb-3">
        <label class="col-sm-3 col-form-label">
          <i class="bi bi-chat-text me-2"></i>Message:
        </label>
        <div class="col-sm-9">
          <textarea
            v-model="formData.message"
            class="form-control"
            rows="4"
            required
            placeholder="Enter event message..."
          ></textarea>
          <div class="form-text">
            <i class="bi bi-info-circle me-1"></i>
            Update the timeline event message
          </div>
        </div>
      </div>
    </form>

    <!-- Footer Buttons -->
    <template #footer>
      <button
        type="button"
        class="btn btn-secondary"
        @click="hide()"
        :disabled="isLoading"
      >
        Cancel
      </button>
      <button
        type="submit"
        form="editHistoryForm"
        class="btn btn-primary"
        :disabled="isLoading"
      >
        <span v-if="isLoading" class="spinner-border spinner-border-sm me-2"></span>
        <i v-else class="bi bi-check-lg me-2"></i>
        {{ isLoading ? 'Saving...' : 'Save Changes' }}
      </button>
    </template>
  </BModal>
</template>

<style scoped>
.spinner-border-sm {
  width: 1rem;
  height: 1rem;
}
</style>